<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="assu_critere1" ref="critere1" v-model="sasAssurance.critere1" :live="liveSasAssurance(9202)" :disabled="estRetraiteAuRenouvellement" />
    <CatalogueLive code="assu_critere2" ref="critere2" v-model="sasAssurance.critere2" :live="liveSasAssurance(9203)" :disabled="estRetraiteAuRenouvellement" />
    <CatalogueLive code="assu_critere3" ref="critere3" v-model="sasAssurance.critere3" :live="liveSasAssurance(9204)" :disabled="estRetraiteAuRenouvellement" />
    <CatalogueLive code="assu_critere4" ref="critere4" v-model="sasAssurance.critere4" :live="liveSasAssurance(9205)" :disabled="estRetraiteAuRenouvellement" />
    <CatalogueLive code="assu_critere5" ref="critere5" v-model="sasAssurance.critere5" :live="liveSasAssurance(9206)" :disabled="estRetraiteAuRenouvellement" />
    <CatalogueLive code="assu_critere6" ref="critere6" v-model="sasAssurance.critere6" :live="liveSasAssurance(9207)" :disabled="estRetraiteAuRenouvellement" />
    <CatalogueLive
      code="assu_categorie_auto"
      ref="categorieCalculee"
      v-model="sasAssurance.categorieDAssuranceCalculee"
      :live="liveSasAssurance(9208)"
      disabled
    />
    <ressource code="tableau_assurance" v-if="categorieCalculee === 'B'" />
    <CatalogueLive
      code="assu_categorie_choix"
      ref="categorieSelectionnee"
      :opqIf="categorieCalculee === 'B'"
      :disabled="estRetraiteAuRenouvellement"
      v-model="sasAssurance.categorieDAssuranceSelectionnee"
      :live="liveSasAssurance(9209)"
      @eudo-updated="updatePanier"
      :filter="
        (fd) =>
          fd.code === 'A' ||
          (fd.code === 'B' && (sas.codeTypeDeSas != '12' || !sasAssurance.categorieDAssuranceLectureSeule))
      "
    />
    <CaseACocherLive
      :opqIf="categorieChoisie === 'B'"
      code="assu_categorie_decla"
      v-model="sasAssurance.declarationCategorieB"
      :live="liveSasAssurance(9211)"
    />
    <CatalogueLive
      code="assu_garantie"
      v-model="sasAssurance.montantGarantie"
      @eudo-updated="updatePanier"
      :live="liveSasAssurance(9210)"
      :disabled="sas.codeTypeDeSas === '12' && sasAssurance.montantGarantieLectureSeule"
      orderBy="code"
    />
    <ressource code="montants-couvertures" />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import { mapActions } from "vuex"

export default {
  mixins: [CataloguesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object, required: true },
    endpoint: { type: String, required: true },
  },
  mounted() {
    if (this.categorieCalculee !== this.getCatalogueCodeById("7903", this.sasAssurance.categorieDAssuranceCalculee)) {
      this.$refs.categorieCalculee.setValueByCode(this.categorieCalculee)
    }
    this.appliquerCategorieRetraite()
  },
  computed: {
    sasAssurance() {
      return this.sas.sasAssurance
    },
    estRetraiteAuRenouvellement() {
      return (
        this.sas.codeTypeDeSas === "08" &&
        this.getCatalogueCodeById("11136", this.sas.sasInscriptionTableau?.categorieDeMembre) === "retraite"
      )
    },
    categorieCalculee() {
      if (this.estRetraiteAuRenouvellement) {
        return "B"
      }

      const ouiUnCritere =
        this.estOui(this.sasAssurance.critere1) ||
        this.estOui(this.sasAssurance.critere2) ||
        this.estOui(this.sasAssurance.critere3) ||
        this.estOui(this.sasAssurance.critere4) ||
        this.estOui(this.sasAssurance.critere5) ||
        this.estOui(this.sasAssurance.critere6)

      const listeAdresses = this.sas.adressesProfessionnellesRenouvellement ?? this.sas.sasAdressesProfessionnelles

      const unEmployeurCategorieA = listeAdresses.some(
        (s) =>
          !s.inactif && (s.codeCategorieEtablissement === "A" || s.codeCategorieEtablissement === "Autre consultation")
      )

      if (ouiUnCritere || unEmployeurCategorieA || this.sasAssurance.natureContientActionnaireOuProprietaire) {
        return "A"
      }

      return "B"
    },
    categorieChoisie() {
      return this.getCatalogueCodeById("7903", this.sasAssurance.categorieDAssuranceSelectionnee)
    },
  },
  watch: {
    categorieCalculee(newValue) {
      this.$refs.categorieCalculee.setValueByCode(newValue)
      this.updatePanier()
    },
    estRetraiteAuRenouvellement() {
      this.appliquerCategorieRetraite()
    },
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: this.endpoint, sasId: this.sas.id })
    },
    // Membre retraité au renouvellement : critères à Non et catégorie B imposés
    appliquerCategorieRetraite() {
      if (!this.estRetraiteAuRenouvellement) {
        return
      }

      for (let i = 1; i <= 6; i++) {
        if (!this.estNon(this.sasAssurance[`critere${i}`])) {
          this.$refs[`critere${i}`].setValueByCode("N")
        }
      }

      // Le choix de catégorie n'apparaît qu'une fois la catégorie calculée passée à B
      this.$nextTick(() => {
        if (this.categorieChoisie !== "B") {
          this.$refs.categorieSelectionnee.setValueByCode("B")
        }
      })
    },
    liveSasAssurance(cle) {
      return { endpoint: "sas-assurance", cle: cle, fileId: this.sasAssurance.id }
    },
  },
}
</script>

<style></style>
